import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentTemplate, TitleHeader } from 'web-library';
import ListDataArchival from '../../modules/admin/components/DataArchival/ListDataArchival';

const DataArchival = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('admin->>DataArchival.DataArchival')} />

      <ContentTemplate type="full">
        <ListDataArchival />
      </ContentTemplate>
    </>
  );
};

export default DataArchival;
